import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { portfolioCashflow } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

export const [actions, reducer, resourceSagas] = resourceReducer(
  'portfolio-cash-flows'
);

function* readPortfolioCashflow() {
  yield takeEvery(actions.indexRequestBegin, function* ({ payload }) {
    const { args } = payload;
    try {
      const result = yield call(portfolioCashflow.get, args);
      const { meta } = result;
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess({ ...normalized, meta, args }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error, args }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readPortfolioCashflow, ...resourceSagas];
